var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "nav",
    { class: _vm.navClasses, attrs: { "aria-label": "Page navigation" } },
    [
      _c(
        "ul",
        { staticClass: "pagination", class: _vm.classes },
        [
          _vm.boundaryLinks
            ? _c(
                "li",
                { class: { disabled: _vm.value <= 1 || _vm.disabled } },
                [
                  _c(
                    "a",
                    {
                      attrs: {
                        href: "#",
                        role: "button",
                        "aria-label": "First",
                      },
                      on: {
                        click: function ($event) {
                          $event.preventDefault()
                          return _vm.onPageChange(1)
                        },
                      },
                    },
                    [
                      _c("span", { attrs: { "aria-hidden": "true" } }, [
                        _vm._v("«"),
                      ]),
                    ]
                  ),
                ]
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.directionLinks
            ? _c(
                "li",
                { class: { disabled: _vm.value <= 1 || _vm.disabled } },
                [
                  _c(
                    "a",
                    {
                      attrs: {
                        href: "#",
                        role: "button",
                        "aria-label": "Previous",
                      },
                      on: {
                        click: function ($event) {
                          $event.preventDefault()
                          return _vm.onPageChange(_vm.value - 1)
                        },
                      },
                    },
                    [
                      _c("span", { attrs: { "aria-hidden": "true" } }, [
                        _vm._v("‹"),
                      ]),
                    ]
                  ),
                ]
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.sliceStart > 0
            ? _c("li", { class: { disabled: _vm.disabled } }, [
                _c(
                  "a",
                  {
                    attrs: {
                      href: "#",
                      role: "button",
                      "aria-label": "Previous group",
                    },
                    on: {
                      click: function ($event) {
                        $event.preventDefault()
                        return _vm.toPage(1)
                      },
                    },
                  },
                  [
                    _c("span", { attrs: { "aria-hidden": "true" } }, [
                      _vm._v("…"),
                    ]),
                  ]
                ),
              ])
            : _vm._e(),
          _vm._v(" "),
          _vm._l(_vm.sliceArray, function (item) {
            return _c(
              "li",
              {
                key: item,
                class: {
                  active: _vm.value === item + 1,
                  disabled: _vm.disabled,
                },
              },
              [
                _c(
                  "a",
                  {
                    attrs: { href: "#", role: "button" },
                    on: {
                      click: function ($event) {
                        $event.preventDefault()
                        return _vm.onPageChange(item + 1)
                      },
                    },
                  },
                  [_vm._v(_vm._s(item + 1))]
                ),
              ]
            )
          }),
          _vm._v(" "),
          _vm.sliceStart < _vm.totalPage - _vm.maxSize
            ? _c("li", { class: { disabled: _vm.disabled } }, [
                _c(
                  "a",
                  {
                    attrs: {
                      href: "#",
                      role: "button",
                      "aria-label": "Next group",
                    },
                    on: {
                      click: function ($event) {
                        $event.preventDefault()
                        return _vm.toPage(0)
                      },
                    },
                  },
                  [
                    _c("span", { attrs: { "aria-hidden": "true" } }, [
                      _vm._v("…"),
                    ]),
                  ]
                ),
              ])
            : _vm._e(),
          _vm._v(" "),
          _vm.directionLinks
            ? _c(
                "li",
                {
                  class: {
                    disabled: _vm.value >= _vm.totalPage || _vm.disabled,
                  },
                },
                [
                  _c(
                    "a",
                    {
                      attrs: {
                        href: "#",
                        role: "button",
                        "aria-label": "Next",
                      },
                      on: {
                        click: function ($event) {
                          $event.preventDefault()
                          return _vm.onPageChange(_vm.value + 1)
                        },
                      },
                    },
                    [
                      _c("span", { attrs: { "aria-hidden": "true" } }, [
                        _vm._v("›"),
                      ]),
                    ]
                  ),
                ]
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.boundaryLinks
            ? _c(
                "li",
                {
                  class: {
                    disabled: _vm.value >= _vm.totalPage || _vm.disabled,
                  },
                },
                [
                  _c(
                    "a",
                    {
                      attrs: {
                        href: "#",
                        role: "button",
                        "aria-label": "Last",
                      },
                      on: {
                        click: function ($event) {
                          $event.preventDefault()
                          return _vm.onPageChange(_vm.totalPage)
                        },
                      },
                    },
                    [
                      _c("span", { attrs: { "aria-hidden": "true" } }, [
                        _vm._v("»"),
                      ]),
                    ]
                  ),
                ]
              )
            : _vm._e(),
        ],
        2
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }